@if (cookiePreferences$(); as cookies) {
  <ul class="content-block-list" #content>
    @for (block of blocksWithContent(); track block.id; let i = $index) {
      <li
        class="content-block-list__item"
        [ngClass]="'type--' + block.blockType + ' ' + sectionSpacing(block.blockType)"
        [id]="'blok-' + i"
        [class.guide-border-top]="showLabels()"
        [attr.id]="blocksListInfo$()[i].anchor"
        [class.pt-header-card-slider]="i === 0 && header()?.type === 'header-card-slider' && block.blockType !== 'block-event'"
        [class.pt-header-search]="i === 0 && header()?.type === 'header-library' && block.blockType !== 'block-event'"
        [class.inset-top-header]="headerHasInsetOption() && i === 0 && block.blockType === 'block-anchor-nav'"
      >
        @if (showLabels() || showAnchors()) {
          <div class="container guide-container">
            @if (showLabels()) {
              <code class="guide-label mb-2">Bloktype: {{ block.cmsblockTypeTitle || block.blockType }}</code>
            }
            @if (showAnchors()) {
              <button (click)="copyToClipboard(blocksListInfo$()[i].anchor)">
                <code class="guide-label mb-2">Anchor: #{{ blocksListInfo$()[i].anchor }}</code>
              </button>
            }
          </div>
        }

        @switch (block.blockType) {
          @case ('block-default') {
            <app-content-block-default
              [index]="i"
              [block]="block"
              [cookiePreferences]="cookies"
              [reversedOrder]="blocksListInfo$()[i].alternate"
            ></app-content-block-default>
          }
          @case ('block-large-media') {
            <app-content-block-large-media [index]="i" [block]="block" [cookiePreferences]="cookies"></app-content-block-large-media>
          }
          @case ('block-cta') {
            <app-content-block-cta [index]="i" [block]="block" [cookiePreferences]="cookies"></app-content-block-cta>
          }
          @case ('block-cta-cards') {
            <app-content-block-cta-cards [index]="i" [block]="block" [cookiePreferences]="cookies"></app-content-block-cta-cards>
          }
          @case ('block-news-featured') {
            <app-content-block-news [index]="i" [block]="block" [cookiePreferences]="cookies"></app-content-block-news>
          }
          @case ('block-wysiwyg') {
            <app-content-block-wysiwyg [index]="i" [block]="block" [cookiePreferences]="cookies"></app-content-block-wysiwyg>
          }
          @case ('block-event') {
            <app-content-block-agenda
              [index]="i"
              [block]="block"
              [cookiePreferences]="cookies"
              [headerType]="i === 0 ? header()?.type : undefined"
            ></app-content-block-agenda>
          }
          @case ('block-locations') {
            <app-content-block-locations [index]="i" [block]="block" [cookiePreferences]="cookies"></app-content-block-locations>
          }
          @case ('block-faq') {
            <app-content-block-faq [index]="i" [block]="block" [cookiePreferences]="cookies"></app-content-block-faq>
          }
          @case ('block-map') {
            <app-content-block-map [index]="i" [block]="block" [cookiePreferences]="cookies"></app-content-block-map>
          }
          @case ('block-collections') {
            <app-content-block-collections [index]="i" [block]="block" [cookiePreferences]="cookies"></app-content-block-collections>
          }
          @case ('block-newsletter') {
            <app-content-block-newsletter [index]="i" [block]="block" [cookiePreferences]="cookies"></app-content-block-newsletter>
          }
          @case ('block-cta-image-cards') {
            <app-content-block-cta-image-cards
              [index]="i"
              [block]="block"
              [cookiePreferences]="cookies"
            ></app-content-block-cta-image-cards>
          }

          @case ('block-anchor-nav') {
            <app-content-block-anchor-nav
              class="block-anchor-link"
              [index]="i"
              [block]="block"
              [blocks]="anchorBlocks()"
              [cookiePreferences]="cookies"
              [debug]="debug()"
            ></app-content-block-anchor-nav>
          }

          @default {
            <app-content-block-base [index]="i" [block]="block" [cookiePreferences]="cookies"></app-content-block-base>
          }
        }
      </li>
    }
  </ul>
}
